import { isNotUndefined } from '@newfront-insurance/core';

import { SchemaDisplayItem } from './components/schema-display/schema-item';
import type { CustomValue } from './components/schema-display/value/registry';
import { SchemaInputControl } from './components/schema-input/control';
import type { SchemaInputControlCustomInput } from './components/schema-input/control/registry';
import type { GroupItem, SchemaFieldType } from './types';

/**
 * Registers a custom value display component and custom input component for a new input type.
 * @param inputType
 * @param customValue
 * @param customInput
 */
export function addCustomSchemaHandler<T, K>(
  inputType: string,
  customValue: CustomValue<T, K>,
  customInput: SchemaInputControlCustomInput<T, K>,
  getStringifiedFieldValue: (value: T, field?: SchemaFieldType<K>) => string | null,
): void {
  SchemaInputControl.registerComponent(inputType, customInput);
  SchemaDisplayItem.registerComponent(inputType, customValue, getStringifiedFieldValue);
}

/**
 * Finds the group item that contains the target field key, then returns that
 * group item with only the target field key.
 * Effectively, this function filters the layout to only show the target field key.
 */
export function filterLayoutForSingleRow(layoutGroupItems: GroupItem[], targetFieldKey: string[]): GroupItem[] {
  return layoutGroupItems
    .map((layoutGroupItem) => {
      const { inputs } = layoutGroupItem;
      const groupItemContainsTargetField = inputs.some((input) => targetFieldKey.includes(input));
      if (groupItemContainsTargetField) {
        // Target field key is found in this group item, return a new group item with only the target field key
        return {
          ...layoutGroupItem,
          inputs: targetFieldKey,
        };
      }
      return undefined;
    })
    .filter(isNotUndefined);
}
